import React, { useEffect, useState } from 'react';

import Tabs from 'components/tabs';
import Layout from 'components/layout';
import CandidateListing from './candidate-listing';

import style from './candidates.module.scss';

const Candidates = () => {
  const [active, setActive] = useState(1);

  useEffect(() => {
    const handlePopState = () => {
      const currentURL = window.location.href;
      if (currentURL.endsWith('/candidate-listing')) {
        setActive(1);
      } else {
        setActive(0);
      }
    };
    handlePopState();
    window.addEventListener('popstate', handlePopState);
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  const handleTabChange = (index) => {
    setActive(index);
    if (index === 1) {
      window.history.pushState(null, '', `/candidates/candidate-listing`);
    } else {
      window.history.pushState(null, '', `/candidates`);
    }
  };

  return (
    <>
      <Layout>
        <div className={style.mainClass}>
          <h1 className={style.h1}>Candidates</h1>
          <div className={style.tabClass}>
            <Tabs
              tabs={tabs}
              active={active}
              setActive={handleTabChange}
              children={tabs[active].children}
            />
          </div>
        </div>
      </Layout>
    </>
  );
};

export default Candidates;

const tabs = [
  { name: 'Dashboard', children: <div>Dashboard</div> },
  {
    name: 'Candidate Listing',
    children: <CandidateListing />,
  },
];
